import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { VEHICLE_DOTACION_CATEGORIES, normalizeVehicleDotacionFields } from '../../services/api';

export const StockForm = ({ material, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    brand: '',
    category: '',
    unit: 'Unidad',
    stockMin: 0,
    stockActual: 0,
    stockMax: 0,
    location: '',
    status: 'Activo',
    price: 0,
    hasSerial: '',
    serial: '',
    requires_vehicle: 0,
    dotacion_category: ''
  });

  useEffect(() => {
    if (material) {
      setFormData(prev => ({
        ...prev,
        ...material,
        brand: material.brand || '',
        hasSerial: material.serial ? 'Sí' : (material.hasSerial || ''),
        serial: material.serial || '',
        ...normalizeVehicleDotacionFields(material)
      }));
    }
  }, [material]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Código *</label>
          <input
            type="text"
            value={formData.code}
            onChange={(e) => setFormData({ ...formData, code: e.target.value })}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Nombre *</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Marca</label>
          <input
            type="text"
            value={formData.brand}
            onChange={(e) => setFormData({ ...formData, brand: e.target.value })}
            className="w-full border rounded px-3 py-2"
            placeholder="Ej: HP, Logitech, etc."
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">¿Tiene serial?</label>
          <select
            value={formData.hasSerial}
            onChange={(e) => setFormData({ ...formData, hasSerial: e.target.value })}
            className="w-full border rounded px-3 py-2"
          >
            <option value="">Seleccione...</option>
            <option value="Sí">Sí</option>
            <option value="No">No</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Categoría *</label>
          <input
            type="text"
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Unidad de Medida</label>
          <select
            value={formData.unit}
            onChange={(e) => setFormData({ ...formData, unit: e.target.value })}
            className="w-full border rounded px-3 py-2"
          >
            <option>Unidad</option>
            <option>Caja</option>
            <option>Paquete</option>
            <option>Litro</option>
            <option>Kilogramo</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Stock Mínimo</label>
          <input
            type="number"
            value={formData.stockMin}
            onChange={(e) => setFormData({ ...formData, stockMin: parseInt(e.target.value) || 0 })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Stock Actual</label>
          <input
            type="number"
            value={formData.stockActual}
            onChange={(e) => setFormData({ ...formData, stockActual: parseInt(e.target.value) || 0 })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Stock Máximo</label>
          <input
            type="number"
            value={formData.stockMax}
            onChange={(e) => setFormData({ ...formData, stockMax: parseInt(e.target.value) || 0 })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Ubicación</label>
          <input
            type="text"
            value={formData.location}
            onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            className="w-full border rounded px-3 py-2"
            placeholder="Ej: A-01"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Precio Unitario</label>
          <input
            type="number"
            value={formData.price}
            onChange={(e) => setFormData({ ...formData, price: parseFloat(e.target.value) || 0 })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Estado</label>
          <select
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
            className="w-full border rounded px-3 py-2"
          >
            <option>Activo</option>
            <option>Inactivo</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">¿Dotación de vehículo?</label>
          <select
            value={formData.requires_vehicle ? '1' : '0'}
            onChange={(e) => {
              const isVehicle = e.target.value === '1';
              setFormData({
                ...formData,
                requires_vehicle: isVehicle ? 1 : 0,
                dotacion_category: isVehicle ? formData.dotacion_category : ''
              });
            }}
            className="w-full border rounded px-3 py-2"
          >
            <option value="0">No</option>
            <option value="1">Sí</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Categoría dotación</label>
          <select
            value={formData.dotacion_category || ''}
            onChange={(e) => setFormData({ ...formData, dotacion_category: e.target.value })}
            className="w-full border rounded px-3 py-2"
            disabled={!formData.requires_vehicle}
          >
            <option value="">{formData.requires_vehicle ? 'Seleccione...' : 'No aplica'}</option>
            {VEHICLE_DOTACION_CATEGORIES.map((c) => (
              <option key={c.key} value={c.key}>{c.label}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="flex gap-2 mt-6">
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded flex items-center gap-2 hover:bg-blue-600"
        >
          <Save size={18} /> Guardar
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="bg-gray-300 px-4 py-2 rounded flex items-center gap-2 hover:bg-gray-400"
        >
          <X size={18} /> Cancelar
        </button>
      </div>
    </form>
  );
};
